export default "__VITE_ASSET__DdVUH_BZ__"